import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowUpRight, FiMail, FiMapPin } = FiIcons;

const logoUrl = 'https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/00698ec216769b881372e89204858926.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-message">
        <p className="eyebrow">Build the next legacy</p>
        <h2>Every young person deserves the tools to move forward.</h2>
        <Link to="/get-involved" className="circle-link" aria-label="Get involved">
          <SafeIcon icon={FiArrowUpRight} />
        </Link>
      </div>

      <div className="footer-grid">
        <div className="footer-brand">
          <img src={logoUrl} alt="Legacy of Immortals" />
        </div>
        <div>
          <h3>Explore</h3>
          <Link to="/programs">Programs</Link>
          <Link to="/about">Our mission</Link>
          <Link to="/get-involved">Get involved</Link>
        </div>
        <div>
          <h3>Connect</h3>
          <a href="mailto:info@example.com">
            <SafeIcon icon={FiMail} /> Email our team
          </a>
          <span>
            <SafeIcon icon={FiMapPin} /> Pacific Northwest
          </span>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Legacy of Immortals</span>
        <span>501(c)(3) nonprofit organization</span>
      </div>
    </footer>
  );
}

export default Footer;